import React from 'react';
import PropTypes from 'prop-types';
import {LOGIN_TO} from '~/constant/login';
import LoginSuccess from '../components/LoginSuccess';
import H5LoginModal from './H5LoginModal';

const H5Login = props => {
    const {to} = props;
    return (
        to === LOGIN_TO.LOGIN_SUCCESS
            ? <LoginSuccess />
            : <H5LoginModal {...props} />
    );

};

H5Login.defaultProps = {
    isNeedToVerify: false,
    captchaId: '',
    phone: '',
    code: '',
    errMsg: '',
};

H5Login.propTypes = {
    to: PropTypes.string.isRequired,
    isNeedToVerify: PropTypes.bool,
    captchaId: PropTypes.string,
    phone: PropTypes.string,
    code: PropTypes.string,
    errMsg: PropTypes.string,
    setErrMsg: PropTypes.func.isRequired,
    loginFunc: PropTypes.func.isRequired
};

export default H5Login;
